import { render, staticRenderFns } from "./TransitionResponsive.vue?vue&type=template&id=318bb3bd&"
import script from "./TransitionResponsive.vue?vue&type=script&lang=js&"
export * from "./TransitionResponsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports